<script>
    import { onMount } from 'svelte';
    import ForceGraph from './ForceGraph.svelte';
    import { getParams, getExecutiveSummary } from './utils.js';
    import { ScaleOut } from 'svelte-loading-spinners';
    import { graphDataStore } from './stores.js';
    import { TWEETS_BASE_URL } from './constants.js';

    const params = getParams();

    let keyword = params.keyword;
    let date = params.date;

    let data;
    let error;

    async function loadGraph(){
        const url = TWEETS_BASE_URL + 'api/tweets/' + keyword + '?date=' + date ;
        try {
            const result = await fetch(url);
            if (!result.ok) {
                throw new Error(result.statusText);
            }
            const response = await result.json();
            data = response['data']['graph'];
            graphDataStore.set(data);
            await getExecutiveSummary(data['top_tweets']);            
        } catch (err) {
            error = err;
            console.log(error);
        }
    }

    onMount(() => {
        loadGraph();  // add parameters as required
    }); 
</script>

<div class="graph-container flex-grow rounded border-4 p-3 pt-0 pb-0">        
    {#if data}
        <ForceGraph 
            {data} 
            nodeId={d => d.id}
            nodeGroup={d => d.group}
            nodeTitle={d => `${d.id}`}
            width={window.innerWidth}
            height={window.innerHeight}
        />
    {:else if error}
        <div class="flex justify-center items-center h-full">
            <p class="bg-red rounded text-white p-4 font-bold opacity-50">ERROR: {error.message}</p>
        </div>
    {:else}
        <div class="flex justify-center items-center h-full">
            <ScaleOut size="200" color="#02A4FF" unit="px" duration="1s"  />
        </div>
    {/if}
</div>
